// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2CHpC","importantInfo":"styles_importantInfo__wRlgB"};